<template>
  <div
    class="header-wrapper border-b border-gainsboro flex flex-row justify-between"
  >
    <div class="flex flex-col justify-center text-xs ml-6">
      <div>
        {{ dataProvider }}
      </div>
      <div class="text-sonicSilver">
        {{ fullName }}
      </div>
    </div>
    <div class="flex flex-row">
      <div class="flex flex-row items-center mr-8" v-if="hasHeaderBtn">
        <component :is="headerBtn" />
      </div>
      <div
        class="header-wrapper__action flex items-center justify-center border-l border-gainsboro cursor-pointer"
        @click="logout"
      >
        <BaseIcon name="exit" width="32" height="32" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
  import BaseIcon from '@/components/global/base-icon';

  export default {
    name: 'MainHeader',

    components: {
      BaseIcon,
    },

    computed: {
      ...mapState('Auth', ['user']),
      ...mapGetters('Auth', ['hasRole']),

      fullName() {
        return this.user.full_name ?? null;
      },

      dataProvider() {
        let provider = this.user.data_provider || {};
        if (this.hasRole('head_plus')) {
          return provider.region || '';
        }
        if (!provider.code || !provider.name) {
          return '';
        }
        return `${provider.code} ${provider.name}`;
      },

      hasHeaderBtn() {
        return typeof this.$route.meta.headerBtn !== 'undefined';
      },

      headerBtn() {
        return this.$route.meta.headerBtn;
      },
    },

    methods: {
      logout() {
        this.$store.dispatch('Auth/logout').then(() => {
          this.$router.push({name: 'auth.login'});
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .header-wrapper {
    height: rem(64px);
    min-height: rem(64px);

    &__action {
      width: rem(64px);
    }
  }
</style>
